module.exports = __webpack_public_path__ + "static/android-app-alt-c2059cc15e73a5d5e38b2bff3b737378.png";